import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzNotificationsModule } from '@blk/daisy/combinations/notifications';
import { DzIconModule } from '@blk/daisy/core/icon';
import { DzCheckboxModule } from '@blk/daisy/elements/selection-controls';
import { SharedModule } from '@ddt-web/common';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';
import { faChevronDown, faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';

import { DropdownFiltersComponent } from './dropdown-filters.component';
import { ModelsExperienceDropdownComponent } from './dropdown/dropdown.component';

@NgModule({
	declarations: [ModelsExperienceDropdownComponent, DropdownFiltersComponent],
	imports: [
		CommonModule,
		CwpNgFrameworkModule,
		FormsModule,
		DzCheckboxModule,
		DzIconModule.withIcons(faChevronDown, faPlus, faMinus),
		DzNotificationsModule,
		SharedModule,
		GenericDirectivesModule
	],
	exports: [ModelsExperienceDropdownComponent, DropdownFiltersComponent]
})
export class DropdownFiltersModule { }
